export default __webpack_public_path__ + "static/media/great_job.07452275.svg";